import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  changeDevops(flag) {
    const op = {
      1: '手动添加设备页',
      2: '在线添加设备页',
      3: '设备迁移页',
      4: '站点详情-设备卡片',
      5: '运维管理页'
    };
    buryPoint.event({
      action: '开启/关闭设备运维-使用功能',
      eventCategory: '开启/关闭设备运维',
      eventLabel: op[flag]
    });
  }
};
